import { apiFetch } from './client';

export interface SubscriberSummary {
  emailHash: string;
  status: 'active' | 'pending' | 'unsubscribed';
  subscribedAt: string;
  unsubscribedAt?: string;
}

export interface SubscriberCounts {
  active: number;
  pending: number;
  unsubscribed: number;
}

export interface ListSubscribersResponse {
  items: SubscriberSummary[];
  counts: SubscriberCounts;
}

export const subscribe = (email: string, consent: boolean) =>
  apiFetch<{ message: string }>('/api/v1/subscribers', {
    method: 'POST',
    body: JSON.stringify({ email, consent }),
  });

export const confirmSubscription = (token: string) =>
  apiFetch<{ message: string }>(`/api/v1/subscribers/confirm?token=${encodeURIComponent(token)}`);

export const unsubscribe = (token: string) =>
  apiFetch<{ message: string }>(
    `/api/v1/subscribers/unsubscribe?token=${encodeURIComponent(token)}`,
  );

export const listSubscribers = (status?: string) =>
  apiFetch<ListSubscribersResponse>(
    `/api/v1/subscribers${status ? `?status=${encodeURIComponent(status)}` : ''}`,
  );
